// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Context for a specific module
 */
export interface ModuleContextOutput {
  moduleId: unknown;
  courseId?: unknown;
  currentTaskId?: unknown;
}
